import React from "react";
import Spinner from "react-spinkit";
//components
import { HeaderText } from "../style";
import { HistoryTable } from "./styles";
import { IHistoryBudgetSale } from "../interface";
import { TableHeader } from "../PriceHistoryTableHeader";
import { PriceHistoryTableRow } from "../PriceHistoryTableRow";
import { Column, Row } from "../../../../../../../components/Layout/Grid";

export const PriceHistoryTable = ({ applyPriceFunction, budgetData, salesData, finishedLoadingTableData }: any) => {
  enum LIST_TYPE {
    budget = 'budget',
    sale = 'sale',
  }

  const spinner = <div style={{ display: 'flex', justifyContent: 'center' }}>
    <Spinner fadeIn="none" name="circle" color="#0E4C54" />
  </div>;

  const renderRows = (dataList: any, dataType: LIST_TYPE) => {
    if (!finishedLoadingTableData) {
      return spinner;
    } else if (dataList?.length > 0) {
      return dataList?.map((item: IHistoryBudgetSale) =>
        <div className="tableRow">
          <PriceHistoryTableRow applyPriceFunction={applyPriceFunction} item={item} />
        </div>
      );
    } else {

      let errorMessage = 'Não há registro de histórico de preço praticado em cotação';
      if (dataType == LIST_TYPE.sale) {
        errorMessage = 'Não há registros de histórico de preços  de venda.';
      }

      return (
        <Column className="noHistory">
          <p>{errorMessage}</p>
        </Column>
      );
    }
  };

  return (
    <>
      <TableHeader />
      <HistoryTable>
        <Column>
          <Column>
            <Row className="tableHeaderLabels">
              <HeaderText >Data</HeaderText>
              <HeaderText>CD</HeaderText>
              <HeaderText>C. Cliente</HeaderText>
              <HeaderText >Rent%</HeaderText>
              <Column>
                <HeaderText>Preço Unitário</HeaderText>
              </Column>
            </Row>
          </Column>
          <Column className="renderRows">
            {renderRows(budgetData, LIST_TYPE.budget)}
          </Column>
        </Column>
        <Column>
          <Column>
            <Row className="tableHeaderLabels">
              <HeaderText >Data</HeaderText>
              <HeaderText>CD</HeaderText>
              <HeaderText>C. Cliente</HeaderText>
              <HeaderText >Rent%</HeaderText>
              <Column>
                <HeaderText>Preço Unitário</HeaderText>
              </Column>
            </Row>
          </Column>
          <Column className="renderRows">
            {renderRows(salesData, LIST_TYPE.sale)}
          </Column>
        </Column>
      </HistoryTable>
    </>
  );
};